<template>
  <div class="card">
    <div class="card-header bg-dark">
      <h3 class="mb-3 text-white">
        รายการถอนทั้งหมด
        <small class="ml-2">({{ dataCount | format(0) }} รายการ)</small>
      </h3>
      <div class="row">
        <div class="col-md-2 col-6">
          <base-input label="วันที่" labelClasses="text-white">
            <flat-picker class="form-control datepicker" v-model="startDate" />
          </base-input>
        </div>
        <div class="col-md-2 col-6">
          <base-input label="ถึง" labelClasses="text-white">
            <flat-picker class="form-control datepicker" v-model="endDate" />
          </base-input>
        </div>

        <div class="col-md-2 col-6">
          <base-input label="สถานะ" labelClasses="text-white">
            <el-select class="select-primary mr-2" v-model="searchStatus">
              <el-option class="select-primary" label="ทั้งหมด" value="" />
              <el-option
                class="select-primary"
                label="รอดำเนินการ"
                value="pending"
              />
              <el-option
                class="select-primary"
                label="รอระบบทำรายการถอน"
                value="queueing"
              />
              <el-option
                class="select-primary"
                label="ถอนเงินสำเร็จ"
                value="success"
              />
              <el-option
                class="select-primary"
                label="ถอนเงินไม่สำเร็จ"
                value="reject"
              />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-2 col-6">
          <base-input label="จำนวนที่แสดง" labelClasses="text-white">
            <el-select
              class="select-primary pagination-select mr-2"
              v-model="pagination.perPage"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-4 col-6">
          <base-input
            label="ค้นหา"
            labelClasses="text-white"
            placeholder="ค้นหา ..."
            v-model="searchQuery"
          />
        </div>
      </div>
    </div>
    <el-table
      row-key="id"
      header-row-class-name="thead-light"
      :data="queriedData"
    >
      <el-table-column label="สมาชิก" min-width="150px">
        <div slot-scope="{ row }">
          <router-link :to="`/dashboard/members?search=${row.member.phone}`">
            {{ row.member.firstName }} {{ row.member.lastName }}
          </router-link>
          <br />
          {{ row.member.phone }}
        </div>
      </el-table-column>
      <el-table-column
        label="จำนวนเงิน"
        min-width="125px"
        prop="amount"
        sortable
      >
        <div slot-scope="{ row }">{{ row.amount | format }}</div>
      </el-table-column>
      <el-table-column label="ถอนไปยัง" min-width="300px">
        <div slot-scope="{ row }">
          <h5 class="font-weight-normal mb-0">
            {{ row.member.bankNumber }}
          </h5>

          <span class="text-dark"
            >{{ row.transferTo | bankName }} ({{ row.transferTo }})</span
          >
          <span class="d-block text-muted mt-1" v-if="row.remark !== ''">{{
            row.remark
          }}</span>
          <span class="d-block text-danger" v-if="row.operator !== ''">
            ทำรายการโดย <b>{{ row.operator }}</b>
          </span>
        </div>
      </el-table-column>
      <el-table-column label="วันที่แจ้งถอน" min-width="200px">
        <div slot-scope="{ row }">
          {{ row.createdAt | moment("DD/MM/YYYY HH:mm:ss") }}
        </div>
      </el-table-column>
      <el-table-column label="สถานะ" align="center" min-width="125px">
        <div slot-scope="{ row }">
          <span class="badge badge-success" v-if="row.status === 'success'">
            ถอนเงินสำเร็จ
          </span>
          <span class="badge badge-danger" v-else-if="row.status === 'reject'">
            ถอนเงินไม่สำเร็จ
          </span>
          <span
            class="badge badge-primary"
            v-else-if="row.status === 'queueing'"
          >
            รอระบบทำรายการถอน
          </span>
          <span class="badge badge-warning" v-else> รอดำเนินการ </span>
        </div>
      </el-table-column>
      <el-table-column
        label="ปรับสถานะ / ยืนยัน / ยกเลิก"
        align="center"
        min-width="175px"
      >
        <div slot-scope="{ row }">
          <div
            v-if="
              row.withdraw.qrString !== '' || row.withdraw.transactionID !== ''
            "
          >
            <button
              class="btn btn-primary btn-sm"
              @click="viewQR(row.withdraw)"
            >
              <i class="fa fa-qrcode" />
            </button>
          </div>
          <div v-if="row.status === 'pending'">
            <button
              class="btn btn-success btn-sm m-1"
              :disabled="loading"
              @click="confirmTx(row.id)"
            >
              ยืนยัน
            </button>
            <button
              class="btn btn-danger btn-sm m-1"
              :disabled="loading"
              @click="rejectTx(row.id)"
            >
              ยกเลิก
            </button>
          </div>
          <button
            v-if="row.status !== 'success'"
              class="btn btn-primary btn-sm mt-1"
              :disabled="loading"
              @click="confirmTx(row.id, false)"
            >
              ปรับสถานะ
          </button>
          <button
            class="btn btn-warning btn-sm mt-1"
            :disabled="loading"
            v-if="
              (hasPermission('rewithdraw') && row.status !== 'pending') ||
              row.status === 'reject'
            "
            @click="redoTx(row.id)"
          >
            ทำรายการใหม่
          </button>
        </div>
      </el-table-column>
    </el-table>
    <div class="card-footer d-flex justify-content-between">
      <p class="card-category">
        Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
      </p>

      <base-pagination
        class="pagination-no-border"
        :per-page="pagination.perPage"
        :total="total"
        v-model="pagination.currentPage"
      />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, FormItem, Select, Option } from "element-ui";
import { BasePagination } from "../components";
import flatPicker from "vue-flatpickr-component";

import moment from "moment";
import TxService from "../services/tx.service";
import tablePagination from "../mixins/tablePagination";
import Swal from "sweetalert2";
import QRCode from "davidshimjs-qrcodejs";
import { mapGetters } from "vuex";

export default {
  mixins: [
    tablePagination([
      "member.firstName",
      "member.lastName",
      "member.phone",
      "amount",
      "remark",
      "createdAt",
    ]),
  ],
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
  },
  data() {
    return {
      loading: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      searchStatus: "",

      dataCount: 0,
      tableData: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
  },
  methods: {
    async fetchWithdraw() {
      try {
        const res = await TxService.fetchWithdraw({
          start: this.startDate,
          end: this.endDate,
          status: this.searchStatus,
        });

        this.dataCount = res.count;
        this.updateTableData(res.transactions);
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      }
    },
    confirmTx(tx, transfer = true) {
      let promptText = `ยืนยันรายการ #${tx}`;
      if (!transfer) {
        promptText = `ปรับสถานะรายการ #${tx}`;
      }

      Swal.fire({
        icon: "info",
        title: promptText,
        showCancelButton: true,
      }).then(async ({ value }) => {
        if (!value) return false;

        try {
          this.loading = true;
          const res = await TxService.confirmTx(tx, transfer);

          this.$notify({ type: "success", message: res.message });
          this.fetchWithdraw();
        } catch ({ message }) {
          this.$notify({ type: "danger", message });
        } finally {
          this.loading = false;
        }
      });
    },
    rejectTx(tx) {
      Swal.fire({
        icon: "info",
        title: `ยกเลิกรายการ #${tx}`,
        input: "text",
        inputAttributes: {
          placeholder: "หมายเหตุ ...",
        },
        showCancelButton: true,
      }).then(async ({ value = false }) => {
        if (!value && value !== "") return false;

        try {
          this.loading = true;
          const res = await TxService.rejectTx(tx, value);

          this.$notify({ type: "success", message: res.message });
          this.fetchWithdraw();
        } catch ({ message }) {
          this.$notify({ type: "danger", message });
        } finally {
          this.loading = false;
        }
      });
    },
    redoTx(tx) {
      Swal.fire({
        icon: "info",
        title: `ทำรายการใหม่ #${tx}`,
        showCancelButton: true,
      }).then(async ({ value }) => {
        if (!value) return false;

        try {
          this.loading = true;
          const res = await TxService.redoTx(tx);

          this.$notify({ type: "success", message: res.message });
          this.fetchWithdraw();
        } catch ({ message }) {
          this.$notify({ type: "danger", message });
        } finally {
          this.loading = false;
        }
      });
    },
    viewQR(withdraw) {
      if (withdraw.qrString !== "") {
        Swal.fire({
          html: `<div class="d-flex justify-content-center">
					<div id="qr" class="ml--2"></div>
				</div>`,
        });

        const qr = new QRCode(document.getElementById("qr"), {
          width: 175,
          height: 175,
        });
        qr.clear();
        qr.makeCode(withdraw.qrString);
      } else {
        const prefix = localStorage.getItem("x-prefix");
        window.open(
          `https://msn.cdnbet.co/withdraw/${prefix}/${withdraw.transactionID}.png`,
          "_blank"
        );
      }
    },
  },
  created() {
    this.fetchWithdraw();
  },
  watch: {
    startDate() {
      this.fetchWithdraw();
    },
    endDate() {
      this.fetchWithdraw();
    },
    searchStatus() {
      this.fetchWithdraw();
    },
  },
};
</script>
